<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";
import {HeroKind} from "@/modules/redactor/models/hero/HeroKind";

export default {
  name: "r-hero-kind",
  props: {
    model: VueTypes.instanceOf(HeroKind),
    label: VueTypes.string.def("Hero:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return HeroKind.getValues();
    }
  }
}
</script>